<template>
  <div v-if="pages" class="C_pagination js-pager">
    <template v-if="!prePage">
      <a href="javascript:;" class="start disabled">首页</a>
      <a href="javascript:;" class="prev disabled">上一页</a>
    </template>
    <template v-else>
      <a href="javascript:;" class="start" @click="pageOffset(1)">首页</a>
      <a href="javascript:;" class="prev" @click="goPrePage">上一页</a>
    </template>
    <template v-for="i in showPageBtn">
      <a v-if="i" :class="i === pageNum ? 'disabled current' : ''" @click="pageOffset(i)">{{i}}</a>
      <span v-else>···</span>
    </template>
    <template v-if="!nextPage">
      <a href="javascript:;" class="next disabled">下一页</a>
      <a href="javascript:;" class="end disabled">尾页</a>
    </template>
    <template v-else>
      <a href="javascript:;" class="next" @click="goNextPage">下一页</a>
      <a href="javascript:;" class="end" @click="pageOffset(pages)">尾页</a>
    </template>
  </div>
</template>

<script>
export default {
  name: 'pagination',
  data () {
    return {
    }
  },
  props: ['pages', 'pageNum'],
  computed: {
    prePage () {
      return this.pageNum !== 1 && this.pages
    },
    nextPage () {
      return (this.pageNum < this.pages) && this.pages
    },
    showPageBtn () {
      let arr = []
      if (this.pages <= 5) {
        for (let i = 1; i <= this.pages; i++) {
          arr.push(i)
        }
        return arr
      }
      if (this.pageNum <= 2) return [1, 2, 3, 0, this.pages]
      if (this.pageNum >= this.pages - 1) return [1, 0, this.pages - 2, this.pages - 1, this.pages]
      if (this.pageNum === 3) return [1, 2, 3, 4, 0, this.pages]
      if (this.pageNum === this.pages - 2) return [1, 0, this.pages - 3, this.pages - 2, this.pages - 1, this.pages]
      return [1, 0, this.pageNum - 1, this.pageNum, this.pageNum + 1, 0, this.pages]
    }
  },
  methods: {
    goPrePage () {
      this.$emit('getData', this.pageNum - 1)
    },

    pageOffset (i) {
      this.$emit('getData', i)
    },

    goNextPage () {
      this.$emit('getData', this.pageNum + 1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ./src/components/pagination.vue